var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.cardFlag)?_c('a-card',{class:_vm.cardClass,attrs:{"title":_vm.titleFlag && _vm.title}},[(_vm.titleFlag)?_vm._t("extra",null,{"slot":"extra"}):_vm._e(),_vm._t("queryForm"),_vm._t("default")],2):[_vm._t("queryForm"),_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }